const awsconfig =  {
    API: {
      GraphQL: {
        endpoint: 'https://qbi3rz2cozfppffkqarnc4lmk4.appsync-api.ap-southeast-1.amazonaws.com/graphql',
        region: 'ap-southeast-1',
        defaultAuthMode: 'apiKey',
        apiKey: 'da2-w5oozojdkrb2rnepb3c4toymjq'
      }
    }
};

export default awsconfig;



// OLD AWSCONFIG
// const awsconfig = {
//     aws_project_region: 'ap-southeast-1', // AWS Region
//     aws_appsync_graphqlEndpoint: 'https://qbi3rz2cozfppffkqarnc4lmk4.appsync-api.ap-southeast-1.amazonaws.com/graphql', // Your AppSync API endpoint
//     aws_appsync_region: 'ap-southeast-1', // Region
//     aws_appsync_authenticationType: 'apiKey', // Authentication method
//     aws_appsync_apiKey: 'da2-w5oozojdkrb2rnepb3c4toymjq', // Your AppSync API key
//   };
  
//   export default awsconfig;
  